import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-upload',
  templateUrl: './loading-upload.component.html',
  styleUrls: ['./loading-upload.component.scss']
})
export class LoadingUploadComponent {

  @Input() color?: any = "#fff";

  constructor() { }
}
